/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Partner_TrustedInputs */

const en_business_partner_trusted = /** @type {(inputs: Business_Partner_TrustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trusted by researchers worldwide`)
};

const es_business_partner_trusted = /** @type {(inputs: Business_Partner_TrustedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizado por investigadores en todo el mundo`)
};

/**
* | output |
* | --- |
* | "Trusted by researchers worldwide" |
*
* @param {Business_Partner_TrustedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_partner_trusted = /** @type {((inputs?: Business_Partner_TrustedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Partner_TrustedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_partner_trusted(inputs)
	return en_business_partner_trusted(inputs)
});